enum LOG_TYPE {
  WIDGET_PROPERTY_VALIDATION_ERROR,
  WIDGET_UPDATE,
  ACTION_EXECUTION_ERROR,
  ACTION_EXECUTION_SUCCESS,
  ENTITY_DELETED,
  EVAL_ERROR,
  ACTION_UPDATE,
}

export default LOG_TYPE;
